import request from "../utils/request";

export function login(data) {
    return request({
        url: '/weblogin/v2',
        method: 'post',
        data,
    });
}

export function logout(data) {
    return request({
        url: '/weblogout',
        method: 'post',
        data
    });
}

// 获取用户信息
export function getInfo(data) {
    return request({
        url: '/workbench/desktop',
        method: 'get',
        data,
    });
}

export function changePassword(data, userId) {
    return request({
        url: `/realms/normal/users/${userId}/changePwd`,
        method: 'put',
        data
    });
}

/**
 * @param {
 *  userId: Number,
 *  userName: String,
 *  menuCode: String,
 * } data 
 * @returns 
 */
//获取用户搜索区域配置
export function getUserSearchConfigApi(data) {
    return request({
        url: `/menu/condition`,
        method: 'get',
        data,
    });
}

/**
 * update page view
 * @param { Object } data
 * @param { Number } data.userId
 * @param { String } data.userName
 * @param { String } data.menuCode
 * @param { String } data.customerCode
 * @param { Array } data.conditions
 * @param { Object } data.tableSetting
 * @param {
 *  conditions: Array<{
 *  key: String, //searchdata key
 *  checked: Boolean,
 *  disabled: Boolean
 * }>
 * } data 
 * @returns 
 */

export function updateUserViewConfigApi(data) {
    return request({
        url: `/menu/condition`,
        method: 'put',
        data
    });
}

/**
 * reset page view config
 * @param { Object } data
 * @param { Number } data.userId
 * @param { String } data.userName
 * @param { String } data.menuCode
 * @param { String } data.type
 * @param { any } data 重置值 可为null
 * @returns 
 */
export function resetUserSearchConfigApi(params, data = null) {
    return request({
        url: `/menu/condition`,
        method: 'delete',
        params,
        data,
    });
}